import Vue from 'vue'
import Router from 'vue-router'
import Store from '../Store'
import Services from '../Service'
import AddBalance from '../Pages/AddBalance.vue'
import AddCategory from '../Pages/Settings/AddCategory.vue'
import AddExtra from '../Pages/AddExtra.vue'
import AddExtraType from '../Pages/AddExtraType.vue'
import AddKitchen from '../Pages/Settings/AddKitchen.vue'
import AddPaymentType from '../Pages/Settings/AddPaymentType.vue'
import AddPlace from '../Pages/Settings/AddPlace.vue'
import AddProduct from '../Pages/AddProduct.vue'
import AddTable from '../Pages/Settings/AddTable.vue'
import AddUser from '../Pages/AddUser.vue'
import Balance from '../Pages/Balance.vue'
import Dashboard from '../Pages/Dashboard.vue'
import EditCategory from '../Pages/Settings/EditCategory.vue'
import EditExtra from '../Pages/EditExtra.vue'
import EditExtraType from '../Pages/EditExtraType.vue'
import EditKitchen from '../Pages/Settings/EditKitchen.vue'
import EditPaymentType from '../Pages/Settings/EditPaymentType.vue'
import EditPlace from '../Pages/Settings/EditPlace.vue'
import EditProduct from '../Pages/EditProduct.vue'
import EditTable from '../Pages/Settings/EditTable.vue'
import EditUser from '../Pages/EditUser.vue'
import Kitchen from '../Pages/Kitchen.vue'
import Table from '../Pages/Table.vue'
import Tables from '../Pages/Tables.vue'
import Products from '../Pages/Products.vue'
import Settings from '../Pages/Settings.vue'
import SettingsCategories from '../Pages/Settings/Categories.vue'
import SettingsChangePassword from '../Pages/Settings/ChangePassword.vue'
import SettingsKitchens from '../Pages/Settings/Kitchens.vue'
import SettingsPaymentTypes from '../Pages/Settings/PaymentTypes.vue'
import SettingsPlaces from '../Pages/Settings/Places.vue'
import SettingsTables from '../Pages/Settings/Tables.vue'
import Staff from '../Pages/Staff.vue'
import Test from '../Pages/Test.vue'

Vue.use(Router)

let RouteHandler = new Router({
  mode: 'history',
  routes: [{
    path: '/Test',
    name: 'Test',
    component: Test
  }, {
    path: '/Balance/Add/:TypeCode',
    name: 'AddBalance',
    component: AddBalance
  }, {
    path: '/Balance',
    name: 'Balance',
    component: Balance
  }, {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  }, {
    path: '/Kitchen',
    name: 'Kitchen',
    component: Kitchen
  }, {
    path: '/Tables',
    name: 'Tables',
    component: Tables
  }, {
    path: '/Tables/:ID',
    name: 'Table',
    component: Table
  }, {
    path: '/Products',
    name: 'Products',
    component: Products
  }, {
    path: '/Products/Add',
    name: 'AddProduct',
    component: AddProduct
  }, {
    path: '/Products/:ID',
    name: 'EditProduct',
    component: EditProduct
  }, {
    path: '/Products/:ID/OptionTypes/Add',
    name: 'AddExtraType',
    component: AddExtraType
  }, {
    path: '/Products/:ProductID/OptionTypes/:ID',
    name: 'EditExtraType',
    component: EditExtraType
  }, {
    path: '/Products/:ID/Options/Add',
    name: 'AddExtra',
    component: AddExtra
  }, {
    path: '/Products/:ProductID/OptionTypes/:TypeID/Options/:ID',
    name: 'EditExtra',
    component: EditExtra
  }, {
    path: '/Settings',
    name: 'Settings',
    component: Settings
  }, {
    path: '/Settings/Categories',
    name: 'SettingsCategories',
    component: SettingsCategories
  }, {
    path: '/Settings/Categories/Add',
    name: 'AddCategory',
    component: AddCategory
  }, {
    path: '/Settings/Categories/:ID',
    name: 'EditCategory',
    component: EditCategory
  }, {
    path: '/Settings/Kitchens',
    name: 'SettingsKitchens',
    component: SettingsKitchens
  }, {
    path: '/Settings/Kitchens/Add',
    name: 'AddKitchen',
    component: AddKitchen
  }, {
    path: '/Settings/Kitchens/:ID',
    name: 'EditKitchen',
    component: EditKitchen
  }, {
    path: '/Settings/PaymentTypes',
    name: 'SettingsPaymentTypes',
    component: SettingsPaymentTypes
  }, {
    path: '/Settings/PaymentTypes/Add',
    name: 'AddPaymentType',
    component: AddPaymentType
  }, {
    path: '/Settings/PaymentTypes/:ID',
    name: 'EditPaymentType',
    component: EditPaymentType
  }, {
    path: '/Settings/Places',
    name: 'SettingsPlaces',
    component: SettingsPlaces
  }, {
    path: '/Settings/Places/Add',
    name: 'AddPlace',
    component: AddPlace
  }, {
    path: '/Settings/Places/:ID',
    name: 'EditPlace',
    component: EditPlace
  }, {
    path: '/Settings/Tables',
    name: 'SettingsTables',
    component: SettingsTables
  }, {
    path: '/Settings/Tables/Add',
    name: 'AddTable',
    component: AddTable
  }, {
    path: '/Settings/Tables/:ID',
    name: 'EditTable',
    component: EditTable
  }, {
    path: '/Settings/ChangePassword',
    name: 'SettingsChangePassword',
    component: SettingsChangePassword
  }, {
    path: '/Staff',
    name: 'Staff',
    component: Staff
  }, {
    path: '/Staff/Add',
    name: 'AddUser',
    component: AddUser
  }, {
    path: '/Staff/:ID',
    name: 'EditUser',
    component: EditUser
  }, ],
});

RouteHandler.beforeEach((to, from, next) => {
  Store.dispatch('ClearLogs');
  Store.dispatch('RemoveAlerts');
  Store.dispatch('SetFocusedData', null);

  Services.Nozich.UnSubAll('Local');

  next();
})

export default RouteHandler